import { z } from 'zod';

export const languageSelectorSchema = z.object({
  country: z.string(),
  language: z.string(),
});

export type LanguageSelectorSchema = z.infer<typeof languageSelectorSchema>;
